var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.dataShowName
      ? _vm.dataShowName
      : _vm.DashboardDataFullScreen.chartInfo
      ? _vm.DashboardDataFullScreen.chartInfo.name
      : '',"visible":_vm.chartFullScreenTo,"width":"85%","center":_vm.titleCenter,"close-on-click-modal":false,"before-close":_vm.chartFullScreenClose},on:{"update:visible":function($event){_vm.chartFullScreenTo=$event}}},[_c('dashboardCard',{attrs:{"DashboardData":_vm.DashboardDataFullScreen,"useLocation":'chartFullScreen'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }